module.exports = __webpack_public_path__ + "img/dice-five.ad99a4e3.svg";